import { render, staticRenderFns } from "./editResourceStoreType.vue?vue&type=template&id=ba016f74&scoped=true"
import script from "./editResourceStoreType.vue?vue&type=script&lang=js"
export * from "./editResourceStoreType.vue?vue&type=script&lang=js"
import style0 from "./editResourceStoreType.vue?vue&type=style&index=0&id=ba016f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba016f74",
  null
  
)

export default component.exports